import React, {FC} from 'react';

type Props = {
  label: string;
  onPress(): void;
};

export const CTAButton: FC<Props> = ({label, onPress}) => (
  <button className="w-full bg- p-5 rounded-lg flex justify-center items-center trakDarkGradient" onMouseDown={onPress}>
    <p className="text-xl text-white text-center">{label}</p>
  </button>
);
